import { render, staticRenderFns } from "./MyPoolShares.vue?vue&type=template&id=4121d156&"
import script from "./MyPoolShares.vue?vue&type=script&lang=js&"
export * from "./MyPoolShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports